import { useEffect, useState } from 'react';

import { CheckIcon } from './icons/Icon.js';

type ToastEntry = { id: number; message: string };

let counter = 0;
const listeners = new Set<(toasts: ToastEntry[]) => void>();
let current: ToastEntry[] = [];

const broadcast = () => {
  for (const listener of listeners) listener(current);
};

export const toast = (message: string) => {
  const entry: ToastEntry = { id: ++counter, message };
  current = [...current, entry];
  broadcast();
  setTimeout(() => {
    current = current.filter((item) => item.id !== entry.id);
    broadcast();
  }, 2200);
};

export const ToastHost = () => {
  const [toasts, setToasts] = useState<ToastEntry[]>(current);

  useEffect(() => {
    listeners.add(setToasts);
    return () => {
      listeners.delete(setToasts);
    };
  }, []);

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-20 z-30 flex flex-col items-center gap-2 px-4">
      {toasts.map((entry) => (
        <div
          key={entry.id}
          role="status"
          className="pointer-events-auto flex items-center gap-2 rounded-full bg-surface px-4 py-2 text-sm text-ink shadow-lg shadow-black/40 border border-ink/10 animate-bubble-in"
        >
          <CheckIcon size={16} className="text-accent" />
          <span>{entry.message}</span>
        </div>
      ))}
    </div>
  );
};
